import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import solaris_el from 'translations/el/solaris.json';
import solaris_en from 'translations/en/solaris.json';

i18n.use(initReactI18next).init({
  debug: process.env.NODE_ENV === 'development',
  lng: 'el',
  fallbackLng: 'en',
  resources: {
    en: {
      solaris: solaris_en,
    },
    el: {
      solaris: solaris_el,
    },
  },
  interpolation: {
    escapeValue: false, // not needed for react as it escapes by default
  },
  react: {
    wait: true,
    useSuspense: false,
  },
});

export default i18n;
